import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  contentSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  divider: {
    margin: 0,
  },
  agreementSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    // FormControlLabel applies root margins (incl. labelPlacement="start"); reset so only this Stack gap controls vertical rhythm.
    '& .MuiFormControlLabel-root': {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
    },
  },
  formControlLabel: {
    flex: 1,
  },
  contentDescriptionHelperText: {
    maxWidth: '80%',
  },
  imageLabel: {
    color: theme.palette.text.secondary,
  },
}));
